export default "__VITE_ASSET__BWLXDsBF__"